// extracted by mini-css-extract-plugin
module.exports = {"TwitterWidget":"TwitterWidget-module--TwitterWidget--1qdD8"};